import React, {Component} from "react";
import DateRange from "../../../payment/common/dateRange";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleDate from "../../../../../modules/SimpleDate";
import M from "moment/moment";
import * as R from "ramda";

class FilterH1 extends Component {
    getValue = (name) => {
        return this.props.state.filterData?.filterH1?.[name];
    };

    setValue = (name, value) => {
        this.props.onValueChange("filterH1", name, value);
    };

    handleChangeDate = (name, dateName, value) => {
        this.props.onDateChange("filterH1", name, dateName, value);
    };

    handleJenisPenjualanChange = (name, value) => {
        this.setValue("leasing", null);
        this.setValue(name, value);
    }

    render() {
        const {options} = this.props;
        return (
            <>
                <DateRange
                    id="date_range_fj"
                    label="Tanggal FJ"
                    startDateName="startDateFJ"
                    endDateName="endDateFJ"
                    data={this.props.state.filterData?.filterH1?.tanggalFJ}
                    onStartDateChange={(name, value) =>
                        this.handleChangeDate("tanggalFJ", name, M(value).format("DD-MM-YYYY"))
                    }
                    onEndDateChange={(name, value) =>
                        this.handleChangeDate("tanggalFJ", name, M(value).format("DD-MM-YYYY"))
                    }
                />
                <SimpleDDL
                    id="select_options_series"
                    box="multiselect"
                    name="listSeries"
                    label="Series"
                    isClearable
                    options={options.seriesOptions}
                    value={this.getValue("listSeries")}
                    onChange={(value, {name}) => this.setValue(name, value)}
                />
                <SimpleDDL
                    id="select_options_tipe"
                    box="multiselect"
                    name="listTipe"
                    label="Tipe"
                    isClearable
                    readOnly={R.or(R.isNil(this.getValue("listSeries")), R.isEmpty(this.getValue("listSeries")?.value))}
                    options={options.tipeOptions}
                    value={this.getValue("listTipe")}
                    onChange={(value, {name}) => this.setValue(name, value)}
                />
                <SimpleDDL
                    id="select_options_varian"
                    box="multiselect"
                    name="listVarian"
                    label="Varian"
                    isClearable
                    readOnly={R.or(R.isNil(this.getValue("listTipe")), R.isEmpty(this.getValue("listTipe")?.value))}
                    options={options.variantOptions}
                    value={this.getValue("listVarian")}
                    onChange={(value, {name}) => this.setValue(name, value)}
                />
                <SimpleDDL
                    id="select_options_warna"
                    box="multiselect"
                    name="listWarna"
                    label="Warna"
                    readOnly={R.or(R.isNil(this.getValue("listVarian")), R.isEmpty(this.getValue("listVarian")?.value))}
                    isClearable
                    options={options.warnaOptions}
                    value={this.getValue("listWarna")}
                    onChange={(value, {name}) => this.setValue(name, value)}
                />
                <SimpleDDL
                    id="select_options_jenis_penjualan"
                    box="search"
                    name="jenisPenjualan"
                    label="Jenis Penjualan"
                    isClearable
                    options={options.jenisPenjualanOptions}
                    value={this.getValue("jenisPenjualan")}
                    onChange={(value, {name}) => this.handleJenisPenjualanChange(name, value)}
                />
                <SimpleDDL
                    id="select_options_jenis_konsumen"
                    box="search"
                    name="jenisKonsumen"
                    label="Jenis Konsumen"
                    isClearable
                    options={options.jenisKonsumenOptions}
                    value={this.getValue("jenisKonsumen")}
                    onChange={(value, {name}) => this.setValue(name, value)}
                />
                <SimpleDDL
                    id="select_options_leasing"
                    box="search"
                    name="leasing"
                    label="Leasing"
                    isClearable
                    readOnly={this.getValue("jenisPenjualan")?.value !== "CREDIT"}
                    options={options.leasingOptions}
                    value={this.getValue("leasing")}
                    onChange={(value, {name}) => this.setValue(name, value)}
                />

                <div className="grid grid-2x gap-20px grid-mobile-none">
                    <div id="grid-1">
                        <SimpleDDL
                            id="select_options_operator_tanggal_beli_terakhir"
                            box="search"
                            label="Operator"
                            name="operatorTanggalBeliTerakhir"
                            isClearable={this.props.state.filterData?.filterH1?.operatorTanggalBeliTerakhir?.value == '' ? false : true}
                            options={options.operatorOptions}
                            // value={this.getValue("operatorTanggalBeliTerakhir")}
                            value={
                              this.getValue("operatorTanggalBeliTerakhir") ||
                              { label: "=", value: "=" } 
                            }
                            onChange={(value, {name}) => this.setValue(name, value)}
                        />
                    </div>
                    <div id="grid-2">
                        <SimpleDate
                            id="date_picker_tanggal_beli_terakhir"
                            label="Tanggal Beli Terakhir"
                            name="tanggalBeliTerakhir"
                            date={this.getValue("tanggalBeliTerakhir")}
                            onChange={(value) => this.setValue("tanggalBeliTerakhir", M(value).format("DD-MM-YYYY"))}
                        />
                    </div>
                </div>
            </>
        )
    }
}

export default FilterH1